<template>
  <router-view />
</template>
<script setup>
import * as echarts from "echarts";
import { provide } from "vue";
const obj = {
  color: '#8D5DD9',
  colorop: '#8D5DD930'
}
 
// 提供变量
provide('obj', obj);


provide("ec", echarts);
</script>
<style lang="less">
:root {
  --global-primary-color: #8D5DD9; /* 默认的主色 */
  --global-primary-ccolor: #8D5DD910; /* 默认的浅主色 */
  --global-primary-colorop: #8D5DD930; /* 浅主色 */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1245px;
  width: 100%;
  height: 100%;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
